import { Z_INDEX } from '../../constants/zIndex';

// ----------------------------------------------------------------------

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.z20,
          zIndex: Z_INDEX.MAX, // Ensure autocomplete dropdown appears above everything, including modals
        },
        popper: {
          zIndex: Z_INDEX.MAX, // Ensure autocomplete popper appears above everything, including modals
        },
      },
    },
  };
}
